module.exports = __webpack_public_path__ + "img/guyu.183f0363.jpg";